// eslint-disable-next-line no-unused-vars
import i18n from '@/plugins/i18n'
import exampleRoutes from '@/components/examples/routes'
import BaseRoutes from '@/app/routes'
/**
DEF
{
  path: '/example',
  name: 'Example',
  component: () => import('@/components/examples/Example.vue'),
  meta: {
    authenticated: true, // Whether to allow only logged in user (Default: false)
    roles: [], // Array of permitted roles
    permissions: [], // Array of permitted permissions
    notLogged: false, // Whether to allow only non-logged user (Default: false)
    debug: false, // Whether to allow only on debug mode (Default: false)
    headerTitle: undefined, // Sets app-bar title for route
    documentTitle: undefined, // Sets tab title for route
    title: undefined // Sets both app-bar & tab title for route
  }
}
 */

/**
:to
{
  path: '/example',
  name: 'Example',
}
 */


/**
 * Auto import routes from all modules
 * @example @/app/Example/routes.js
 * @example @/app/../routes.js - nested dir is allowed
 * ! multi nested is allowed
 * ? limit to only @/app/./routes.js file ?
 */
// eslint-disable-next-line no-unused-vars
function getAutoImportRoute(){
  const req = import.meta.globEager('../app/**/routes.js', { eager: true, import: 'default' })

  const autoImportRoutes = []

  Object.keys(req).forEach((file) => {
    const data = req[file]

    if (!data) { throw new Error(`No default export in '${file}'`) }
    // must array
    if (!Array.isArray(data)) { throw new Error(`Default export must be an array in '${file}'`) }
    // every item must be object
    if (!data.every((item) => typeof item === 'object')) { throw new Error(`Every item must be an object in '${file}'`) }

    // loop every item
    for (let i = 0; i < data.length; i++) {
      const e = data[i]
      autoImportRoutes.push(e)
    }
  })

  console.log('autoImportRoutes', autoImportRoutes)
  return autoImportRoutes
}

const routes = [
  // ...getAutoImportRoute(),
  ...BaseRoutes,
  ...exampleRoutes,
  {
    path: '*',
    redirect: '/404'
  }
]
export default routes
